import { useEffect } from 'react';
import WebApp from '@twa-dev/sdk';
import { LockOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

interface BlockedScreenProps {
  onLogout: () => void;
}

export default function BlockedScreen({ onLogout }: BlockedScreenProps) {
  const { t } = useTranslation('provider');

  useEffect(() => {
    WebApp.BackButton.hide();
    WebApp.MainButton.hide();
  }, []);

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bl-surface-soft, #f7f8fa)',
      padding: '32px 24px',
      paddingBottom: 'calc(32px + env(safe-area-inset-bottom, 0px))',
      boxSizing: 'border-box',
      textAlign: 'center',
    }}>
      {/* Lock icon */}
      <div style={{
        width: 80,
        height: 80,
        borderRadius: 24,
        background: '#fef2f2',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 36,
        color: '#ef4444',
        marginBottom: 24,
      }}>
        <LockOutlined />
      </div>

      {/* Title */}
      <p style={{
        margin: '0 0 12px',
        fontSize: 20,
        fontWeight: 800,
        color: 'var(--bl-text-strong, #0f172a)',
        lineHeight: 1.3,
      }}>
        {t('blocked.title')}
      </p>

      {/* Description */}
      <p style={{
        margin: '0 0 40px',
        fontSize: 14,
        color: 'var(--bl-text-muted, #9ca3af)',
        lineHeight: 1.6,
        maxWidth: 280,
      }}>
        {t('blocked.description')}
      </p>

      {/* Logout button */}
      <button
        type="button"
        onClick={onLogout}
        style={{
          width: '100%',
          maxWidth: 320,
          height: 50,
          borderRadius: 14,
          background: 'var(--bl-surface, #fff)',
          border: '1px solid var(--bl-divider, #ebebeb)',
          color: '#ef4444',
          fontSize: 15,
          fontWeight: 700,
          cursor: 'pointer',
          fontFamily: 'inherit',
          WebkitTapHighlightColor: 'transparent',
        }}
      >
        {t('blocked.logoutBtn')}
      </button>
    </div>
  );
}
